import { RECEIVE_INVOICEITEMS_SUCCESS } from './contants';

export const invoiceItemsReducer = (state = {}, action) => {
  switch (action.type) {
    case RECEIVE_INVOICEITEMS_SUCCESS:
      return {
        ...state,
        ...action.payload.invoices.reduce((acc, next) => {
          return { ...acc, [next._id]: next };
        }, {}),
      };
    default:
      return state;
  }
};
